import React from 'react';
import { Form } from 'react-bootstrap';
import 'assets/css/textcomponent.css';

// 数値のみの文字列を扱うコンポーネント
function NumberStringComponent(props) {
  const handleChange = (e) => {
    const value = e.target.value;

    // 数字以外の文字は除去
    if (/^\d*$/.test(value)) {
      if (props.onChange) {
        props.onChange(e.target);
      }
    }
  };

  return (
    <Form.Control
      type="text"
      inputMode="tel"
      className={props.className}
      value={props.value}
      disabled={props.disabled}
      onChange={handleChange}
      maxLength={props.maxLength}
    />
  );
}

export default NumberStringComponent;
